(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('BulkUploadCtrl', bulkUploadCtrl);

    function bulkUploadCtrl($scope, $mdDialog, saveLibrary) {
        $scope.saveLibrary = saveLibrary;

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();
